import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import ButtonBorderWidth from "%/dynamic-components/render-engine/options/button-options/button-border-width";
import ButtonBorderColor from "%/dynamic-components/render-engine/options/button-options/button-border-color";

export default class ButtonBorderOptions extends BaseOptionsBundle {
  optionTitle = "Button Borders";
  static optionClassName = "i-dynamic-button-borders";
  inspectorToolGroup = "button-borders";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.BUTTON_BORDERS_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new ButtonBorderWidth(undefined, hideFromInspector["button-border-width"] ?? false),
      new ButtonBorderColor(undefined, hideFromInspector["button-border-color"] ?? false),
    ]);
  }
}
